import { render, staticRenderFns } from "./PInputGLN.vue?vue&type=template&id=36b39f44"
import script from "./PInputGLN.vue?vue&type=script&lang=js"
export * from "./PInputGLN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports